import React from "react";
import { I18n } from "@aws-amplify/core";
import { ForgotPassword } from "aws-amplify-react";

import {
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Input,
  InputLabel,
  Button,
  FormField,
  Link,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

import { auth } from "aws-amplify-react/dist/Amplify-UI/data-test-attributes";

export default class CustomForgotPassword extends ForgotPassword {
  constructor(props) {
    super(props);
    this._validAuthStates = ["forgotPassword"];
  }

  renderUsernameField(theme) {
    return (
      <FormField theme={theme}>
        <InputLabel theme={theme}>{I18n.get("Email")} *</InputLabel>
        <Input
          autoFocus
          placeholder={I18n.get("Enter your email")}
          theme={theme}
          key="email"
          name="username"
          onChange={this.handleInputChange}
          data-test={auth.genericAttrs.emailInput}
        />
      </FormField>
    );
  }

  showComponent(theme) {
    const { hide, authData = {} } = this.props;
    if (hide && hide.includes(CustomForgotPassword)) {
      return null;
    }

    return (
      <FormSection theme={theme} data-test={auth.forgotPassword.section}>
        <SectionHeader
          theme={theme}
          data-test={auth.forgotPassword.headerSection}
        >
          {I18n.get("Reset your password")}
        </SectionHeader>
        <SectionBody theme={theme} data-test={auth.forgotPassword.bodySection}>
          {this.state.delivery || authData.username
            ? this.submitView()
            : this.sendView()}
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            {this.state.delivery || authData.username ? (
              <Button
                theme={theme}
                onClick={this.submit}
                data-test={auth.forgotPassword.submitButton}
              >
                {I18n.get("Submit")}
              </Button>
            ) : (
              <Button
                theme={theme}
                onClick={this.send}
                data-test={auth.forgotPassword.sendCodeButton}
              >
                {I18n.get("Send Code")}
              </Button>
            )}
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            {this.state.delivery || authData.username ? (
              <Link
                theme={theme}
                onClick={this.send}
                data-test={auth.forgotPassword.resendCodeLink}
              >
                {I18n.get("Resend Code")}
              </Link>
            ) : (
              <Link
                theme={theme}
                onClick={() => this.changeState("signIn")}
                data-test={auth.forgotPassword.backToSignInLink}
              >
                {I18n.get("Back to Sign In")}
              </Link>
            )}
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}
